// extracted by mini-css-extract-plugin
export default {"container":"PeerValue_container__Y-pwC","infoBoxWrapper":"PeerValue_infoBoxWrapper__KNlCm"};